<script setup lang="ts">
import { downloadFileBlob } from "@/composables/helperUtils";
import TrackingService from "@/services/trackingservice/tracking.service";

const props = defineProps({
  content_type: {
    type: String,
    required: true,
  },
  contents: {
    type: String,
    required: false,
  },
  description: {
    type: String,
    required: true,
  },
  featuredImage: {
    type: String,
    required: false,
  },
  download: {
    type: String,
    required: true,
  },
});

const downloadPdf = async () => {
  try {
    TrackingService.trackEvent("downloadedContent", {
      contentType: props.content_type,
      content: props.contents,
      fileName: props.download,
    });

    const response = await fetch(props.download, { mode: "cors" });
    if (!response.ok) {
      console.error("Network response was not ok");
    }
    const blob = await response.blob();
    downloadFileBlob(blob, "bonus-perk.pdf");
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};
</script>
<template>
  <div>
    <h2 class="mb-3">Bonus Perk</h2>
    <img class="mb-3" :src="featuredImage" />
    <div class="mb-2"><strong v-html="description"></strong></div>
    <p v-html="contents"></p>
    <div class="my-3">
      <b-button @click="downloadPdf" class="btn btn-primary"
        ><font-awesome-icon icon="fa-icon fa-download" class="pe-2" />Download
        PDF</b-button
      >
    </div>
  </div>
</template>
